import { useNavigation } from 'react-router'

import LoginScreen, {
  type LoginActionData
} from '../components/auth/LoginScreen'
import { ServerError } from '../components/shared/ErrorPages'
import {
  signInAction,
  signInLoader,
  type SignInRouteLoaderData
} from '../features/auth/route.server'
import { useCapturedRouteError } from '../utilities/errorHandlers'

export const loader = signInLoader

export const action = signInAction

export default function SignInRoute({
  loaderData,
  actionData
}: {
  actionData?: LoginActionData
  loaderData: SignInRouteLoaderData
}) {
  const navigation = useNavigation()
  const isLoading =
    navigation.state === 'loading' &&
    navigation.location?.pathname === '/sign-in'

  const isSubmitting = navigation.state === 'submitting'

  return (
    <LoginScreen
      accounts={loaderData.accounts}
      actionData={actionData}
      apiMode={loaderData.apiMode}
      defaultEmail={loaderData.defaultEmail}
      isLoading={isLoading}
      isSubmitting={isSubmitting}
    />
  )
}

export function ErrorBoundary() {
  const error = useCapturedRouteError()
  console.error(error)

  return <ServerError />
}
